<template>
  <el-dialog id="dialog" custom-class="detail-pop" :visible.sync="showPopDetail" :before-close="hidePopDetail" :modal-append-to-body="false">

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="商品信息" name="first">
        <el-scrollbar style="height:100%">
          <el-table ref="detailTable" :data="detailData.childproduct.data" lazy>
            <el-table-column label="商品图片" width="120">
              <template slot-scope="scope"><img width="80" height="80" :src="$url(scope.row.productImg)"></template>
            </el-table-column>
            <el-table-column prop="productId" label="商品编号" width="100"></el-table-column>
            <el-table-column prop="productname" label="商品名称" width=""></el-table-column>
            <el-table-column prop="sku" label="SKU" width="100"></el-table-column>
            <el-table-column prop="number" label="数量" width="100"></el-table-column>
            <el-table-column prop="uPrice" label="单价" width="100"></el-table-column>
            <el-table-column class-name="order-child-status" prop="status" label="订单状态" width="100"></el-table-column>
          </el-table>
          <el-form ref="form" :model="detailData">
            <el-form-item label="订单编号">{{detailData.order_id}}</el-form-item>
            <el-form-item label="订单类型">
              <template>
              {{detailData.order_type}}&nbsp;&nbsp;<span v-if="detailData.type == 6">拼团编号{{detailData.list_id}}</span>
              </template>
              </el-form-item>
            <el-form-item label="订单金额">{{detailData.orderprice}}</el-form-item>
            <el-form-item label="优惠金额">{{detailData.couponprice}}</el-form-item>
            <el-form-item class="form-payLine" label="实际支付：">{{detailData.order_status=='待付款' ? '（未付款）' : detailData.trueprice}}</el-form-item>
          </el-form>
        </el-scrollbar>
      </el-tab-pane>

      <el-tab-pane label="收货人信息" name="second">

        <el-form ref="receiver_form" :model="receiver_form" :rules="receiver_form.rules" label-width="80px">
          <el-form-item label="姓名：" prop="receiver_name">
            <el-input v-if="!receiver_save && this.detailData.order_status=='待发货'||!receiver_save && this.detailData.order_status=='待付款'" v-model="receiver_form.receiver_name"></el-input><span v-else>{{receiver_form.receiver_name}}</span>
          </el-form-item>
          <el-form-item label="手机号码：" prop="receiver_mobile">
            <el-input v-if="!receiver_save && this.detailData.order_status=='待发货'||!receiver_save && this.detailData.order_status=='待付款'" v-model.number="receiver_form.receiver_mobile" maxlength="11"></el-input><span v-else>{{receiver_form.receiver_mobile}}</span>
          </el-form-item>
          <el-form-item label="收货地址：" prop="receiver_address">
            <!-- <el-select v-model="orderDetail.consignee.address" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select> -->
            <el-input type="textarea" v-if="!receiver_save && this.detailData.order_status=='待发货'||!receiver_save && this.detailData.order_status=='待付款'" v-model="receiver_form.receiver_address"></el-input><span v-else>{{receiver_form.receiver_address}}</span>
          </el-form-item>
          <el-form-item v-if="rolesApi.indexOf('api_orders_update_receiver')>=0" v-show="!receiver_save && this.detailData.order_status=='待发货'||!receiver_save && this.detailData.order_status=='待付款'">
            <el-button @click="resetForm">重置</el-button>
            <el-button type="primary" @click="onRece_Submit(receiver_form)">保存</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="配送信息" name="third">
        <el-form ref="express_form" :model="express_form" :rules="express_form.rules" label-width="80px">
          <el-form-item label="物流配送" prop="express_name">
            <el-input v-if="!express_save&&this.detailData.order_status=='待发货'" v-model="express_form.express_name"></el-input><span v-else>{{express_form.express_name}}</span>
          </el-form-item>
          <el-form-item label="物流编号：" prop="express_num">
            <el-input v-if="!express_save&&this.detailData.order_status=='待发货'" v-model="express_form.express_num"></el-input><span v-else>{{express_form.express_num}}</span>
          </el-form-item>
          <el-form-item v-if="rolesApi.indexOf('api_orders_delivery')>=0" v-show="!express_save&&this.detailData.order_status=='待发货'">
            <el-button type="primary" @click="onExpr_Submit(express_form)">确认发货</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

  </el-dialog>
</template>
<script>
export default {
  props: ["showPopDetail", "detailData", "param"],
  data () {
    let phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
    let validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("号码不能为空!!"));
      }
      setTimeout(() => {
        if (!phoneReg.test(value)) {
          callback(new Error("格式有误"));
        } else {
          callback();
        }
      }, 500);
    };
    return {
      activeName: "first",
      type: this.detailData.order_type,
      order_id: this.detailData.order_id,
      receiver_save: false,
      receiver_form: {
        receiver_name: this.detailData.receiver_name,
        receiver_mobile: this.detailData.receiver_mobile,
        receiver_address: this.detailData.receiver_address,
        rules: {
          receiver_name: [
            { required: true, message: "请填写收货人姓名", trigger: "blur" }
          ],
          receiver_mobile: [
            {
              required: true,
              validator: validatePhone,
              trigger: "blur"
            }
          ],
          receiver_address: [
            { required: true, message: "请填写详细地址", trigger: "blur" }
          ]
        }
      },
      express_save: false,
      express_form: {
        express_name: this.detailData.express_name,
        express_num: this.detailData.express_num,
        rules: {
          express_name: [
            { required: true, message: "请填写配送公司", trigger: "blur" }
          ],
          express_num: [
            { required: true, message: "请填写物流编号", trigger: "blur" }
          ]
        }
      }
    };
  },
  watch: {
    param () {
      this.type = this.param.type;
      this.order_id = this.param.order_id;
    }
  },
  computed: {
    rolesApi: {
      get: function () {
        return this.$store.state.rolesApi;
      },
      set: function () { }
    }
  },
  methods: {
    //收货人提交
    onRece_Submit () {
      //验证
      this.$refs["receiver_form"].validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/v1/update/receiver", {
              type: this.getType(this.type),
              order_id: this.order_id,
              name: this.receiver_form.receiver_name,
              mobile: this.receiver_form.receiver_mobile,
              address: this.receiver_form.receiver_address
            })
            .then(res => {
              if (res.data.status == "200") {

                this.$popup("收货人信息修改成功!", "success");
                //改变输入框状态
                this.receiver_save = true;
              } else {
                this.$popup(res.data.msg, "error");
              }
            });
        } else {
          this.$popup("填写错误", "error");
          return false;
        }
      });
    },
    onExpr_Submit () {
      this.$refs["express_form"].validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/v1/update/delivery", {
              type: this.getType(this.type),
              order_id: this.order_id,
              isdelivery: 1,
              express_name: this.express_form.express_name,
              express_no: this.express_form.express_num
            })
            .then(res => {
              if (res.data.status == "200") {
                this.$popup("发货成功!", "success");
                // 改变输入框状态
                this.express_save = true;
                // 列表刷新
                this.$store.dispatch("setUpdataOrderList", true);
              } else {
                this.$popup(res.data.msg, "error");
              }
            });
        } else {
          this.$popup("填写错误", "error");
          return false;
        }
      });
    },
    handleClick () { },
    resetForm () {
      this.receiver_form.receiver_name = '';
      this.receiver_form.receiver_mobile = '';
      this.receiver_form.receiver_address = '';
    },
    hidePopDetail () {
      this.$emit("popDetailfn", false);
    },
    getType (text) {
      switch (text) {
        case "普通":
          return "1";
          break;
        case "秒杀":
          return "2";
          break;
        case "优惠券":
          return "3";
          break;
        case "助力商品":
          return "4";
          break;
        case "砍价":
          return "5";
          break;
        case "拼团":
          return "6";
          break;
        case "其他":
          return "0";
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style lang="less">
.el-dialog.detail-pop {
  width: 980px;
  height: auto;
  margin: 0px auto;
  max-height: 600px;
  padding: 0px;
  background-color: #ffffff;
  .el-dialog__header {
    position: absolute;
    right: 0;
    height: 20px;
    width: 100px;
    z-index: 1;
  }
  .el-dialog__title {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    /*height: calc(100vh - 400px);*/
    .el-scrollbar__view {
      overflow-x: hidden;
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
    .el-scrollbar__thumb {
      background-color: #c5c5c5;
    }
    .el-tabs__header,
    .el-tabs__nav-scroll,
    .el-tabs__nav,
    .el-tabs__item {
      height: 53px;
      line-height: 53px;
    }
    .el-tabs__header {
      padding-left: 24px;
      margin-bottom: 10px;
      border-bottom: 1px solid #f6f8fb;
      .el-tabs__nav-wrap::after {
        height: 0;
      }
      .el-tabs__item.is-active {
        color: #081234;
      }
      .el-tabs__active-bar {
        background-color: #2e71fe;
        height: 4px;
      }
    }
    .order-child-status {
      color: #ff6529;
    }
    .el-tabs__content {
      height: 520px;
      &:first-child {
        padding: 0;
      }
      .el-tab-pane {
        height: 520px;
        .el-scrollbar__wrap {
          padding: 0 60px !important;
          .el-form {
            padding: 30px 0 0 0;
          }
          .el-form-item {
            margin-bottom: 0;
          }
          .el-form-item__label {
            width: 80px !important;
          }
          .el-form-item__content {
            margin-left: 80px !important;
          }
        }
      }
      .el-button {
        padding: 0;
        width: 76px;
        height: 37px;
        text-align: center;
        line-height: 37px;
        border-radius: 19px;
      }
      .el-form {
        padding: 20px 60px;
        padding-bottom: 50px;
        .form-payLine {
          float: right;
          width: 180px;
          overflow: hidden;
          padding-bottom: 40px;
          text-align: right;
          .el-form-item__content {
            color: #ff6529;
            font-weight: bold;
          }
        }
      }
    }

    .el-table thead {
      color: #081234;
    }
    .el-table td,
    .el-table th.is-leaf {
      border-bottom: none;
    }
  }
  .el-form {
    padding: 0 30px;
    .el-form-item {
      margin-bottom: 20px;
      .el-form-item__label {
        width: 100px !important;
        font-weight: bold;
        color: #081234;
        text-align: left;
        padding: 0;
      }
      .el-form-item__content {
        width: 300px;
        // height: 45px;
        text-align: left;
        margin-left: 100px !important;
        .el-input__inner,
        .el-textarea__inner {
          background-color: #f6f8fb;
          border-radius: 0;
        }
        .el-textarea__inner {
          height: 80px;
        }
        .el-switch {
          margin-right: 6px;
        }
        .el-switch .el-switch__core:after {
          background-color: #2e71fe;
        }
        .el-switch.is-checked .el-switch__core:after {
          background-color: #ffffff;
        }
      }
    }
    .top-line {
      margin-top: 15px;
      padding-top: 8px;
      border-top: 1px solid #f6f8fb;
    }
  }
}
.el-message {
  z-index: 3001 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/popover/popDetail.vue